import * as Yup from 'yup';
import { OOO_DESCRIPTION_MAX, TEXT_FIELD_REGEX, TEXT_FIELD_MESSAGE } from 'constants/fieldLimits';

const outOfOfficeValidationSchema = Yup.object().shape({
  startDate: Yup.date().nullable().required('Start date is required'),
  endDate: Yup.date().nullable().required('End date is required'),
  description: Yup.string()
    .nullable()
    .required('Description is required')
    .max(OOO_DESCRIPTION_MAX, `Description must be ${OOO_DESCRIPTION_MAX} characters or less`)
    .matches(TEXT_FIELD_REGEX, TEXT_FIELD_MESSAGE),
  requestType: Yup.string().nullable().required('Request type is required'),
});

export default outOfOfficeValidationSchema;
